import { useTranslation } from "react-i18next";

import { TruckIcon, UserIcon } from "@heroicons/react/24/outline";
import LoadingPulse from "../../../shared/LoadingPulse";
import { DocumentType } from "../../../../models/Document";
import Tooltip from "../../../shared/Tooltip";

export default function LeadDocumentCell({
  loading, documents
}: {
  loading: boolean;
  documents: any[] | null;
}) {
  const { t } = useTranslation("leads");
  const vehicleImages = documents?.filter(i => i.type === DocumentType.Vehicle) ?? null;
  const customerImages = documents?.filter(i => i.type === DocumentType.Customer) ?? null;

  if (loading) return <LoadingPulse />;

  return (
    <div className="flex items-start justify-center flex-col gap-4">
      {vehicleImages && vehicleImages.length > 0 && (
        <Tooltip content={t("Vehicle images")}>
          <div className="relative flex items-center justify-center gap-2">
            <TruckIcon className="w-6 h-6 text-white bg-primary-600 p-1 rounded-full" />
            <div className="font-semibold text-primary-600">{vehicleImages.length}</div>
          </div>
        </Tooltip>
      )}

      {customerImages && customerImages.length > 0 && (
        <Tooltip content={t("Customer images")}>
          <div className="relative flex items-center justify-center gap-2">
            <UserIcon className="w-6 h-6 text-white bg-primary-600 p-1 rounded-full" />
            <div className="font-semibold text-primary-600">{customerImages.length}</div>
          </div>
        </Tooltip>
      )}
    </div>
  )
}